import { Card, Group, Text } from '@logz-ui/styleguide';
import React from 'react';
import { LogzGraphTestSubjects } from '@logz-pkg/enums';
import { TooltipComponent } from '../types';
import { formatNumbers } from '../utils/utils';
import { TooltipContainer } from './TooltipContainer';
import { TooltipLabel } from './TooltipLabel';

export const DefaultTooltipComponent: React.FC<TooltipComponent> = ({
  x,
  points = [],
  format,
  nowHovered,
  maxRenderItems,
  vertical = false,
  unit,
  sortFn,
  valueFormatter,
  timezone,
}) => {
  const renderValue = (y?: number): string => {
    if (valueFormatter) {
      return typeof y === 'number' && Number.isFinite(y) ? valueFormatter(y) : '';
    }

    return y ? formatNumbers(y) : '';
  };

  const sortedPoints = points
    .sort(
      sortFn ||
        ((a, b) => {
          if (b.y && a.y) {
            return b.y - a.y;
          }

          return 0;
        }),
    )
    .slice(0, maxRenderItems);

  return (
    <TooltipContainer
      vertical={vertical}
      date={x}
      format={format}
      timezone={timezone}
      subject={LogzGraphTestSubjects.TooltipComponent}
    >
      {sortedPoints.map((point, i) => {
        return (
          <Card
            highlight={points.length > 1 && point.name === nowHovered}
            justifyContent={'space-between'}
            alignItems={'baseline'}
            key={i}
            borderRadius={5}
            borderless
            width={'100%'}
            p={'3px 8px'}
          >
            <Group vertical={vertical} justifyContent={'space-between'} alignItems={'baseline'} width={'100%'}>
              <TooltipLabel vertical={vertical} point={point} />
              <Text>
                {renderValue(point.y)}
                {unit ? unit : ''}
              </Text>
            </Group>
          </Card>
        );
      })}
    </TooltipContainer>
  );
};
